import { render } from "./UpVoucher310.vue?vue&type=template&id=1023dbf6&scoped=true"
import script from "./UpVoucher310.vue?vue&type=script&lang=js"
export * from "./UpVoucher310.vue?vue&type=script&lang=js"

import "./UpVoucher310.vue?vue&type=style&index=0&id=1023dbf6&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1023dbf6"]])

export default __exports__